import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Athletic chip: filled or outline per variant (matches analysis mockups).
 */
export function StatusBadge({ variant, children, showSpinner, outline }) {
  const base =
    'rounded-full px-3 py-1 text-xs font-display font-bold uppercase tracking-wide inline-flex items-center gap-1';
  const filled = {
    pending: 'bg-amber-500/20 text-amber-300',
    processing: 'bg-amber-500/20 text-amber-300',
    complete: 'bg-beachvision-teal/25 text-beachvision-teal',
    failed: 'bg-red-500/20 text-red-400',
    strength: 'bg-beachvision-teal/25 text-beachvision-teal',
    needs_work: 'bg-beachvision-coral/20 text-beachvision-coral',
  };
  const outlined = {
    pending: 'bg-transparent ring-1 ring-amber-400/50 text-amber-300',
    processing: 'bg-transparent ring-1 ring-amber-400/50 text-amber-300',
    complete: 'bg-transparent ring-1 ring-beachvision-teal/60 text-beachvision-teal',
    failed: 'bg-transparent ring-1 ring-red-400/50 text-red-400',
    strength: 'bg-transparent ring-1 ring-beachvision-teal/70 text-beachvision-teal',
    needs_work: 'bg-transparent ring-1 ring-beachvision-coral/80 text-beachvision-coral',
  };
  const map = outline ? outlined : filled;
  const styles = map[variant] || map.pending;
  return (
    <span className={`${base} ${styles}`}>
      {showSpinner ? <Loader2 className="h-3 w-3 animate-spin" aria-hidden /> : null}
      {children}
    </span>
  );
}
